import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unionPush",
  "use": "icon-unionPush-usage",
  "viewBox": "0 0 33.739 35.957",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33.739 35.957\" id=\"icon-unionPush\">\r\n  <path id=\"icon-unionPush_推广_1_\" data-name=\"推广 (1)\" d=\"M90.184,33.508V0L78.942,7.469h-22.5v18.54h4.1l2.013,9.949h9.059L69.6,26.009h9.347Zm-2.329-4.355-7.393-4.937V9.258l7.393-4.912Zm-19.179,4.47H64.413l-1.476-7.615H67.2ZM60,23.68H58.771V9.8H71.646V23.678Zm18.131,0H73.976V9.8h4.152Z\" transform=\"translate(-56.445)\" fill=\"#1890ff\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol